export function getBoxShadow(transformer) {
    return Object.freeze({
        none: transformer.boxShadow('none'),
        close: transformer.boxShadow('0px 2px 5px 0px rgba(65, 65, 65, 0.23)'),
        far: transformer.boxShadow('0px 4px 12px 0px rgba(65, 65, 65, 0.15)'),
        // Android constraints the types of shadows
        // This shadow is meant to use as shadow above a page footer, equal to Android elevation 24
        // @see https://material.io/archive/guidelines/material-design/elevation-shadows.html#elevation-shadows-elevation-android
        extraFar: transformer.boxShadow('0px 0px 12px 4px rgba(65, 65, 65, 0.15)'),
    });
}
